module.exports = __webpack_public_path__ + "assets/img/con3-bg.e3b77ece.jpg";